import React from 'react';

import { FormErrorsContext } from './context';

export const useFormErrorsContext = () => {
  const values = React.use(FormErrorsContext);

  return values;
};
